// GDPR cookie consent state shared between banner, footer and tracking.

const KEY = "mbo_cookie_consent";
const CHANGE_EVT = "mbo:consent";
const OPEN_EVT = "mbo:cookie-prefs";

export const defaultConsent = { necessary: true, analytics: false, marketing: false };

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    if (raw === "accepted") return { ...defaultConsent, analytics: true, marketing: true };
    if (raw === "rejected") return { ...defaultConsent };
    if (raw === "preferences") return null;
    return { ...defaultConsent, ...JSON.parse(raw), necessary: true };
  } catch (e) {
    return null;
  }
}

export function saveConsent(consent) {
  const value = { ...defaultConsent, ...consent, necessary: true, ts: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(value));
  window.dispatchEvent(new CustomEvent(CHANGE_EVT, { detail: value }));
  return value;
}

export function hasMarketingConsent() {
  return !!getConsent()?.marketing;
}

export function onConsentChange(cb) {
  const handler = (e) => cb(e.detail);
  window.addEventListener(CHANGE_EVT, handler);
  return () => window.removeEventListener(CHANGE_EVT, handler);
}

export function openCookiePreferences() {
  window.dispatchEvent(new Event(OPEN_EVT));
}

export function onOpenCookiePreferences(cb) {
  window.addEventListener(OPEN_EVT, cb);
  return () => window.removeEventListener(OPEN_EVT, cb);
}
